import type { ThemeMode } from '@/hooks/useLightMode'

import { Button, Flex, Spinner, Stack, Text } from '@hivewatch/dark'

import { settingsColorToken } from '../utils/settingsColorToken'

interface SettingsStateMessageIProps {
  actionLabel?: string
  body?: string
  colorScheme: ThemeMode
  isLoading?: boolean
  onAction?: () => void
  title?: string
}

export const SettingsStateMessage = ({
  actionLabel,
  body,
  colorScheme,
  isLoading = false,
  onAction,
  title,
}: SettingsStateMessageIProps) => (
  <Flex
    alignItems='center'
    direction='column'
    justifyContent='center'
    minH='180px'
    px='24px'
    textAlign='center'
  >
    {isLoading ? (
      <Spinner colorScheme={colorScheme} size='lg' />
    ) : (
      <Stack alignItems='center' gap='8px'>
        {title && (
          <Text
            as='h4'
            color={settingsColorToken(colorScheme, 'text.primary')}
            textStyle='body-bold'
          >
            {title}
          </Text>
        )}
        {body && (
          <Text
            color={settingsColorToken(colorScheme, 'text.secondary')}
            maxW='480px'
            textStyle='body'
          >
            {body}
          </Text>
        )}
        {actionLabel && onAction && (
          <Button
            colorScheme={colorScheme}
            onClick={onAction}
            variant='secondary'
          >
            {actionLabel}
          </Button>
        )}
      </Stack>
    )}
  </Flex>
)
